var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyPlayListActiveArrow = function SvgMyPlayListActiveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MyPlayListActiveArrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#423DCF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17.046 8h6m-11 6.5h11m-22 7h22M1 2.97c0-.746.758-1.211 1.364-.839l8.182 5.03c.606.373.606 1.305 0 1.677l-8.182 5.03C1.758 14.242 1 13.777 1 13.03z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MyPlayListActiveArrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMyPlayListActiveArrow;